var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5508 1.48438H14.8438V0.59375C14.8438 0.265852 14.5779 0 14.25 0C13.9221 0 13.6562 0.265852 13.6562 0.59375V1.48438H5.34375V0.59375C5.34375 0.265852 5.07794 0 4.75 0C4.42206 0 4.15625 0.265852 4.15625 0.59375V1.48438H2.44922C1.0987 1.48438 0 2.58307 0 3.93359V16.5508C0 17.9013 1.0987 19 2.44922 19H16.5508C17.9013 19 19 17.9013 19 16.5508V3.93359C19 2.58307 17.9013 1.48438 16.5508 1.48438ZM2.44922 2.67188H4.15625V3.26562C4.15625 3.59352 4.42206 3.85938 4.75 3.85938C5.07794 3.85938 5.34375 3.59352 5.34375 3.26562V2.67188H13.6562V3.26562C13.6562 3.59352 13.9221 3.85938 14.25 3.85938C14.5779 3.85938 14.8438 3.59352 14.8438 3.26562V2.67188H16.5508C17.2465 2.67188 17.8125 3.23787 17.8125 3.93359V5.34375H1.1875V3.93359C1.1875 3.23787 1.75349 2.67188 2.44922 2.67188ZM16.5508 17.8125H2.44922C1.75349 17.8125 1.1875 17.2465 1.1875 16.5508V6.53125H17.8125V16.5508C17.8125 17.2465 17.2465 17.8125 16.5508 17.8125Z",
    fill: "#696969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.d35cb4fd17286d5b3e85831ea13456ea.svg";
export { ForwardRef as ReactComponent };